// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useEventLogService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getAllEventLog = async () => {
        const res = await axios.get(`${apiUrl}/event-log/summary`);

        return res.data;
    };

    return {
        getAllEventLog,
    };
};
